<template>
  <div class="admin_main_page">
    <adHeader></adHeader>
    <div class="wrapper">
      <ad-sidebar></ad-sidebar>
      <div class="main-page">
        <keep-alive>
          <router-view v-if='$route.meta.keepAlive'></router-view>
        </keep-alive>
        <router-view v-if='!$route.meta.keepAlive'></router-view>
      </div>
      <right-nav></right-nav>
    </div>
    <adFooter></adFooter>
  </div>
</template>
<script>
import adSidebar from '@/common/adminArea/sidebar';
import adHeader from '@/common/adminArea/header';
import adFooter from '@/common/adminArea/footer';
import rightNav from '@/common/adminArea/right-nav';
export default {
  data() {
    return {
      ops: {
        showDelay: 500,
        onlyShowBarOnScroll: true,
        keepShow: false,
        background: '#c1c1c1',
        opacity: 0,
        hoverStyle: false,
        specifyBorderRadius: false,
        minSize: false,
        size: '6px',
        disable: true
      }
    };
  },
  components: {
    adSidebar,
    adHeader,
    adFooter,
    rightNav
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminPage/index.vue